<template>
  <span>

    <span v-if="button" @click="showTaskModal(task)" class="cursor-pointer">
        {{ button }}
    </span>
    <span v-else>
      <b-button class="mr-2"
                variant="success"
                @click="showTaskModal(task)"
                qid="delete-s-cancel-button"
      >

        <span v-if="task">
          {{ $t('tasks.open_button') }}
        </span>
        <span v-if="!task">
          {{ $t('tasks.open_first_task') }}
        </span>
      </b-button>
    </span>
    <!-- Task panel, in the engagement task panel's design (US 9478) -->
    <TaskPanelFrame ref="task-modal"
                    qid="bia-task-panel"
                    :crumb="selectedTask && selectedTask.project ? [selectedTask.project.title, selectedTask.scope ? selectedTask.scope.name : ''] : []"
                    :title="selectedTask && selectedTask.model ? selectedTask.model.name : ''"
                    :status="selectedTask ? selectedTask.status : ''"
                    :users="selectedTask && selectedTask.users ? selectedTask.users : []"
                    :due-date="selectedTask && selectedTask.project ? selectedTask.project.end_date : ''"
                    @close="hideTaskModal"
    >
      <template #meta>
        <span v-if="selectedTask && selectedTask.model">
          <a href="#" class="v2-link" @click.prevent="navigateToTask(selectedTask)" data-qid="bia-task-panel-asset">
            <font-awesome-icon :icon="assetIcon(selectedTask.model)" class="mr-1"/>{{ selectedTask.model.name }}
          </a>
        </span>
      </template>

      <section class="v2-field task-panel-form" v-if="selectedTask && selectedTask.model" data-qid="bia-task-panel-form">
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form qid="create-p-form" v-if="selectedTask && selectedTask.model">
        <div class="form-container mt-0 mb-2">
          <div class="row mt-1">
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('tasks.modal.response_label') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedAnswer"
                    :options="allAnswers"
                    :custom-label="answerLabel"
                    :multiple="false"
                    :taggable="false"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('tasks.modal.response_placeholder')"
                ></multiselect>
              </b-form-group>
            </div>
            <div class="col-sm-6" v-if="selectedTask.code != 'system_impact_assessment'">

              <b-form-group v-if="selectedTask && selectedTask.add_description && selectedTask.add_description == 'Optional' || selectedTask.add_description == 'Mandatory'">
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.remarks_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_description == 'Mandatory'">*</span>
                </label>
                <b-form-textarea
                  qid="create-s-form-description"
                  v-model="taskForm.remarks"
                  rows="6"
                  max-rows="6"
                  :required="selectedTask.add_description == 'Mandatory'"
                  :placeholder="$t('tasks.modal.remarks_placeholder')"
                ></b-form-textarea>
              </b-form-group>
              <div class="mt-2" v-if="selectedTask && selectedTask.add_attachments && selectedTask.add_attachments == 'Optional' || selectedTask.add_attachments == 'Mandatory'">
                <label>
                  {{ $t('maintenance.policies.create.attachments') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_attachments == 'Mandatory'">*</span>
                  &nbsp;
                  <span class="text-muted">({{ $t('attachments.file_size_label') }})</span>
                </label>
                <br>
                <p v-for="file in getMedia('task')">
                  <span class="float-right btn btn-link btn-inline-icons cursor-pointer"
                        @click="openDeleteAttachmentModal(file)"
                        qid="remove-media-item"
                  >
                    <font-awesome-icon icon="trash-alt" />
                  </span>
                  <span class="mr-3 float-right text-muted cursor-pointer"
                        @click="downloadMedia(file)"
                        qid="download-media"
                  >
                    <font-awesome-icon icon="cloud-download-alt" />
                  </span>
                  <a href="#" @click="downloadMedia(file)" qid="create-p-media-item">
                    {{ file.file_name }}
                  </a>
                </p>
                <label class="btn btn-secondary cursor-pointer"
                       qid="create-p-file-button"
                >
                  <input type="file"
                         name="fileupload"
                         value="fileupload"
                         multiple
                         id="file"
                         @change="onFileChange"
                         @click="resetFile"
                  >
                  <span>
                    <font-awesome-icon icon="cloud-upload-alt" />
                    {{ $t('system.upload') }}
                  </span>
                </label>
                <br>
              </div>
              <div class="mt-4" v-if="selectedTask && selectedTask.add_attachments && selectedTask.add_attachments == 'Optional' || selectedTask.add_attachments == 'Mandatory'">
                <label>
                  {{ $t('maintenance.policies.create.links_label') }}
                  <span class="text-red" v-if="selectedTask && selectedTask.add_attachments == 'Mandatory'">*</span>
                </label>
                <div v-if="getLinks('task')">
                  <p v-for="link in getLinks('task')" >
                    <span class="float-right btn btn-link btn-inline-icons cursor-pointer"
                          @click="openDeleteLinkModal(link)"
                          qid="view-p-remove-link"
                    >
                      <font-awesome-icon icon="trash-alt" />
                    </span>
                    <a :href="link.url" target="_blank" qid="create-p-link-item">
                      {{ link.name ? link.name : link.url }}
                    </a>
                  </p>
                </div>
                <div v-if="showInput">
                  <label class="mt-2">{{ $t('system.link') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLink"
                    :placeholder="$t('maintenance.third_parties.create.links_placeholder')"
                    qid="create-p-links"
                  ></b-form-input>
                  <label class="mt-2">{{ $t('table.name') }}</label>
                  <b-form-input
                    type="text"
                    aria-describedby="inputGroup"
                    v-model="inputLinkName"
                    :placeholder="inputLink ? inputLink : $t('table.name')"
                    qid="create-p-links"
                  ></b-form-input>
                  <div class="text-right mt-2">
                    <span class="btn btn-success cursor-pointer mr-0"
                          id="inputGroup"
                          @click="handleLink"
                          qid="handle-link-save"
                    >
                      {{ $t('system.save') }}
                    </span>
                  </div>
                </div>
                <span class="btn btn-link cursor-pointer"
                      @click="showInput = true"
                      qid="add-another-link"
                >
                  <font-awesome-icon icon="plus"/> {{ $t('system.add_link') }}
                </span>
                <br>
              </div>
            </div>

            <!-- System risk task form -->
            <div class="col-sm-6" v-if="selectedTask.code == 'system_impact_assessment'">
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.confidentiality.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedConfidentialityImpact"
                    :options="impactItems"
                    :placeholder="$t('processes.risk.impact_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="confidentiality-form-impact"
                ></multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.integrity.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedIntegrityImpact"
                    :options="impactItems"
                    :placeholder="$t('processes.risk.impact_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="confidentiality-form-impact"
                ></multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-s-tags-label">
                  {{ $t('processes.availability.title') }}
                  <span class="text-red">*</span>
                </label>
                <multiselect
                    v-model="selectedAvailabilityImpact"
                    :options="impactItems"
                    :placeholder="$t('processes.risk.impact_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    qid="confidentiality-form-impact"
                ></multiselect>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rto_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input
                      qid="create-s-form-name"
                      type="number"
                      min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')"
                      v-model="taskForm.rto"
                    ></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect
                        v-model="rtoInterval"
                        :options="intervalOptions"
                        :placeholder="$t('projects.schedule.interval_placeholder')"
                        label="text"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-p-form-pg"
                    ></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.rpo_label') }}
                  <span class="text-red">*</span>
                </label>
                <div class="row">
                  <div class="col-sm-6">
                    <b-form-input
                      qid="create-s-form-name"
                      type="number"
                      min="0"
                      :placeholder="$t('projects.schedule.every_placeholder')"
                      v-model="taskForm.rpo"
                    ></b-form-input>
                  </div>
                  <div class="col-sm-6">
                    <multiselect
                        v-model="rpoInterval"
                        :options="intervalOptions"
                        :placeholder="$t('projects.schedule.interval_placeholder')"
                        label="text"
                        :select-label="$t('system.dropdown_select_label')"
                        :selected-label="$t('system.dropdown_selected_label')"
                        :deselect-label="$t('system.dropdown_deselect_label')"
                        qid="create-p-form-pg"
                    ></multiselect>
                  </div>
                </div>
              </b-form-group>
              <b-form-group>
                <label qid="create-p-users-label">
                  {{ $t('tasks.modal.remarks_label') }}
                  <span class="text-red">*</span>
                </label>
                <b-form-textarea
                    qid="create-s-form-description"
                    v-model="taskForm.remarks"
                    rows="6"
                    max-rows="6"
                    :required="selectedTask.add_description == 'Mandatory'"
                    :placeholder="$t('tasks.modal.remarks_placeholder')"
                ></b-form-textarea>
              </b-form-group>
            </div>

          </div>
        </div>
      </b-form>


      </section>

      <template #rail>
        <TaskPanelHelp v-if="selectedTask && selectedTask.project"
                       :project="selectedTask.project"
                       :can-open-project="isOwner(selectedTask.project)"
                       :guide="getGuide(selectedTask.code) ? wpGuide : null"
                       :welcome-guide="welcomeGuide"
                       @open-guide="openGuide()"
                       @open-welcome="openWelcomePage()"
                       @download="downloadMedia"
        ></TaskPanelHelp>
      </template>

      <template #hint>
        <span v-if="selectedTask && selectedTask.project">{{ $t('projects.hero.task_progress') }} <b>{{ project_progress }}%</b></span>
      </template>
      <template #actions>
        <b-button variant="secondary"
                  @click="nextTask()"
                  :disabled="loadingFullList || buttonDisabled || (taskList && taskList.length === 1) || !taskList.length"
                  qid="create-p-submit-button"
        >{{ $t('system.skip') }}<font-awesome-icon icon="chevron-right" class="ml-1"/></b-button>
        <b-button variant="success"
                  v-if="selectedTask.code != 'system_impact_assessment'"
                  @click="completeTask()"
                  :disabled="loadingFullList || buttonDisabled || !taskList.length"
                  qid="create-p-cancel-button"
        ><font-awesome-icon icon="check" class="mr-1"/>{{ $t('tasks.modal.complete') }}</b-button>
        <b-button variant="success"
                  v-if="selectedTask.code == 'system_impact_assessment'"
                  @click="completeSystemRiskTask()"
                  :disabled="loadingFullList || buttonDisabled || !taskList.length"
                  qid="create-p-complete-sia-button"
        ><font-awesome-icon icon="check" class="mr-1"/>{{ $t('tasks.modal.complete') }}</b-button>
      </template>
    </TaskPanelFrame>

    <b-modal ref="all-done" hide-footer @hide="hideDoneModal" size="lg" modal-class="all-done-modal">

      <template #modal-header="{ close }">
        <div class="text-center pt-2 pb-2" style="width: 100%;">
          <span @click="hideDoneModal" class="btn btn-secondary btn-sm cursor-pointer float-right">
            <font-awesome-icon icon="times"/>
          </span>
          <h3>DONE!!!</h3>
        </div>
      </template>

      <img width="100%" src="@/assets/allDoneGif.gif" alt="">

    </b-modal>


    <ConfirmRemoveAttachment
        :object="selectedFile"
        :show="showDeleteAttachmentModal"
        type="file"
        @closeConfirmModal="closeDeleteAttachmentModal"
    ></ConfirmRemoveAttachment>

    <ConfirmRemoveAttachment
        :object="selectedLink"
        :show="showDeleteLinkModal"
        type="link"
        @closeConfirmModal="closeDeleteLinkModal"
    ></ConfirmRemoveAttachment>

    <GuideViewModal
        :guide="selectedGuide"
        :showModal="viewGuideModal"
        @closeViewModal="closeViewGuideModal"
    ></GuideViewModal>

    <ShowMoreModal
        :items="selectedItem.users"
        :show="showUsersModal"
        @closeViewModal="closeUsersModal"
        type="users"
    ></ShowMoreModal>

  </span>

</template>

<script>
  import RichTextView from '@/components/richText/RichTextView.vue';
  import piincHttp from '@/util/configureAxios.js'
  import TaskPanelFrame from '@/components/tasks/TaskPanelFrame.vue';
  import TaskPanelHelp from '@/components/tasks/TaskPanelHelp.vue';
  import { assetIcon } from '@/components/tasks/taskPanel.js';
  import Datepicker from 'vuejs-datepicker';
  import {config} from '@/config.js';
  import ConfirmRemoveAttachment from '@/components/ConfirmRemoveAttachment.vue';
  import GuideViewModal from '@/components/guide/GuideViewModal.vue';
  import roleCheck from "@/util/ACL/roleCheck"
  import Avatar from '@/components/Avatar.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';


  export default {
    name: 'AssessmentTaskModal',
    data: function() {
      return {
        taskForm: {
          remarks: '',
          rto: '',
          rpo: ''
        },
        selectedTask: [],
        buttonDisabled: false,
        selectedFile: {},
        selectedLink: {},
        showDeleteAttachmentModal: false,
        showDeleteLinkModal: false,
        showInput: false,
        showSingleLinkLabel: true,
        inputLink: '',
        inputLinkName: '',
        descriptionLength: config.descriptionLength,
        showFullProjectMessage: false,
        showFullTaskDescription: false,
        showFullGenericControlDescription: false,
        error: '',
        taskList: [],
        selectedAnswer: [],
        allAnswers: [],
        impactItems: [
          { name: this.$t('impact.very_low'), value: 'Very low' },
          { name: this.$t('impact.low'), value: 'Low' },
          { name: this.$t('impact.high'), value: 'High' },
          { name: this.$t('impact.very_high'), value: 'Very high' }
        ],
        intervalOptions: [
          {text: this.$t('system.interval_seconds'), value: 'Seconds'},
          {text: this.$t('system.interval_minutes'), value: 'Minutes'},
          {text: this.$t('system.interval_hours'), value: 'Hours'},
          {text: this.$t('system.interval_days'), value: 'Days'},
          {text: this.$t('system.interval_months'), value: 'Months'},
          {text: this.$t('system.interval_years'), value: 'Years'},
        ],
        selectedConfidentialityImpact: [],
        selectedIntegrityImpact: [],
        selectedAvailabilityImpact: [],
        rtoInterval: [],
        rpoInterval: [],
        project_progress: 0,
        selectedGuide: {},
        viewGuideModal: false,
        welcomeGuide: {},
        selectedItem: {},
        showFullGuideDescription: false,
        wpGuide: {},
        myGuides: [],
        showUsersModal: false,
        loadingFullList: false
      }
    },
    props: {
      task: {},
      tasks: {},
      fromHomepage: {},
      button: ''
    },
    components: {
      TaskPanelFrame,
      TaskPanelHelp,
    RichTextView,
      Datepicker,
      ConfirmRemoveAttachment,
      GuideViewModal,
      Avatar,
      ShowMoreModal
    },
    computed: {
      // The response to save: the title of a drop-down option, or the text of a Select or Yes/No answer
      answer() {
        const value = this.selectedAnswer;
        if (value && typeof value === 'object' && !Array.isArray(value)) {
          return value.title || '';
        }
        return typeof value === 'string' ? value : '';
      },
      getClient() {
        return this.$store.state.client
      },
      getUser() {
        return this.$store.state.user
      },
      getWordpressLink() {
        return this.$store.state.wordpressLink
      },
      getReportMedia() {
        let media = []

        media = _.filter(this.selectedTask.project.media, function(mediaItem) {
          return mediaItem.collection_name == 'documents' || mediaItem.collection_name == 'project';
        });

        return media
      },
      getReportLinks() {
        let links = []

        links = _.filter(this.selectedTask.project.links, function(link) {
          return link.collection == null;
        });

        return links
      }
    },
    watch: {
      getClient: function () {

      }
    },
    methods: {
      assetIcon,
      answerLabel(option) {
        return option && typeof option === 'object' ? option.title : option;
      },
      getMedia(type) {
        let media = []
        if (type == 'task') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'documents';
          });
        }

        if (type == 'question') {
          media = _.filter(this.selectedTask.media, function(mediaItem) {
            return mediaItem.collection_name == 'question';
          });
        }
        return media
      },
      getDifference(endDate) {
        var moment = require('moment');
        let currentDate = moment()
        endDate = moment(endDate);
        let difference = endDate.diff(currentDate, 'days');
        return difference;
      },
      openGuide() {
        if (this.wpGuide && this.wpGuide.link) {
          window.open(this.wpGuide.link, '_blank')
        }
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Task' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
            piincHttp.get(self.getWordpressLink + self.myGuides[0].external_id).then(function(response) {
              self.wpGuide = response.data
            }, function() {});
          }
        }, function() {});
      },
      getLinks(type) {
        let links = []
        if (type == 'task') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == null;
          });
        }

        if (type == 'question') {
          links = _.filter(this.selectedTask.links, function(link) {
            return link.collection == 'question';
          });
        }
        return links
      },
      getReducedUsers(users) {
        let reducedUsers = []
        if (users) {
          if (users.length > 3) {
            reducedUsers = _.cloneDeep(users);
            reducedUsers = reducedUsers.slice(0, 3);
          } else {
            reducedUsers = users;
          }
        }
        return reducedUsers;
      },
      openUsersModal(object) {
        this.selectedItem = object
        this.showUsersModal = true
      },
      closeUsersModal() {
        this.selectedItem = {}
        this.showUsersModal = false
      },
      showListOfTasks() {
        this.hideTaskModal()
        this.$emit('showViewModal');
      },
      showTaskModal(object) {

        let self = this;
        let perPage = 100
        this.error = '';
        this.loadGuides('assessment_task')

        if (object != null) {
          this.selectedTask = object
          this.loadTaskById(this.selectedTask.id, true);
          this.populateForm()
          if (this.tasks && this.tasks.id) {
            self.loadingFullList = true
            piincHttp.get('projects/' + this.tasks.slug + '/tasks/me/small', { params:
              {
                status: 'pending',
                per_page: perPage,
              }
            }).then(function(response) {
              self.taskList = response.data.items;
              self.loadingFullList = false
            }, function() {});
          }
        }

        if (object == null && this.tasks && this.tasks.length) {
          this.selectedTask = this.tasks[0]
          this.loadTaskById(this.selectedTask.id, true);
          this.populateForm()
        }

        if (object == null && this.tasks && this.tasks.id) {
          self.loadingFullList = true
          piincHttp.get('projects/' + this.tasks.slug + '/tasks/me', { params:
            {
              status: 'pending',
              per_page: 1,
            }
          }).then(function(response) {
            self.selectedTask = response.data.items[0];
            self.loadTaskById(self.selectedTask.id, true);
            self.populateForm()
            piincHttp.get('projects/' + self.tasks.slug + '/tasks/me/small', { params:
              {
                status: 'pending',
                per_page: perPage,
              }
            }).then(function(response) {
              self.taskList = response.data.items;
              self.loadingFullList = false
            }, function() {});
          }, function() {});
        }

        this.$refs['task-modal'].show()
        this.loadTaskGuide()
      },
      hideTaskModal() {
        // Kept so the task can be opened again from the sidebar
        this.$store.commit('storeLastClosedTask', this.selectedTask);
        let self = this;
        this.error = '';

        setTimeout(function(){
          self.$emit('reloadContent');
          self.selectedTask = {}
        }, 500);

        this.saveTask();

        if (this.taskList.length && !this.doNotMinimize) {
          this.minimizeTask();
        }

        self.$store.commit('storeUpdateTasks', true);

        this.$refs['task-modal'].hide()
      },
      navigateToProject(task) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', task);
        this.$router.push({ name: 'projects.view', params: { slug: task.project.slug }})
      },
      showViewGuideModal(object) {
        this.selectedGuide = object
        this.viewGuideModal = true
      },
      closeViewGuideModal() {
        this.selectedGuide = ''
        this.viewGuideModal = false
      },
      populateForm() {
        let self = this;

        self.taskForm.remarks = self.selectedTask.remarks

        // Drop-down options are {title, value, color, icon} since US 9398; older Select options are plain text
        if (self.selectedTask.response_type == 'Select' || self.selectedTask.response_type == 'Dropdown') {
          self.allAnswers = JSON.parse(self.selectedTask.response_type_options)
        } else {
          self.allAnswers = ['Yes', 'No']
        }

        self.selectedAnswer = []
        if (self.selectedTask.response) {
          self.selectedAnswer = _.find(self.allAnswers, function(item) {
            if(item === self.selectedTask.response || (item && item.title === self.selectedTask.response)){
              return self.selectedTask.response;
            }
          });
        }

        this.selectedConfidentialityImpact = []
        if (self.selectedTask.confidentiality) {
          self.selectedConfidentialityImpact = _.find(self.impactItems, function(item) {
            if(item.value === self.selectedTask.confidentiality){
              return item
            }
          });
        }

        this.selectedIntegrityImpact = []
        if (self.selectedTask.integrity) {
          self.selectedIntegrityImpact = _.find(self.impactItems, function(item) {
            if(item.value === self.selectedTask.integrity){
              return item
            }
          });
        }

        this.selectedAvailabilityImpact = []
        if (self.selectedTask.availability) {
          self.selectedAvailabilityImpact = _.find(self.impactItems, function(item) {
            if(item.value === self.selectedTask.availability){
              return item
            }
          });
        }

        this.rtoInterval = []
        if (self.selectedTask.rto_type) {
          self.rtoInterval = _.find(self.intervalOptions, function(item) {
            if(item.value === self.selectedTask.rto_type){
              return item
            }
          });
        }

        this.rpoInterval = []
        if (self.selectedTask.rpo_type) {
          self.rpoInterval = _.find(self.intervalOptions, function(item) {
            if(item.value === self.selectedTask.rpo_type){
              return item
            }
          });
        }

        this.taskForm.rto = this.selectedTask.rto_number
        this.taskForm.rpo = this.selectedTask.rpo_number

      },
      openWelcomePage() {
        this.showViewGuideModal(this.welcomeGuide)
      },
      navigateToTask(object) {
        if (this.isOwner(object.model)) {
          this.$store.commit('storeTaskToolbarState', true);
          this.$store.commit('storeActiveTask', object);
          if (object.model_type == 'App\\Activity\\Models\\Activity') {
            this.$router.push({ name: 'activities.view', params: { slug: object.model.slug }, query: { task: object.id }})
          }
          if (object.model_type == 'App\\Process\\Models\\Process') {
            this.$router.push({ name: 'processes.view', params: { slug: object.model.slug }, query: { task: object.id }})
          }
          if (object.model_type == 'App\\System\\Models\\System') {
            this.$router.push({ name: 'systems.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
          if (object.model_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
            this.$router.push({ name: 'contracts.view', params: { slug: object.model.slug, }, query: { task: object.id }})
          }
        }
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin') || roleCheck('Validator') || this.getUser.isAdmin) {
            allow = true
          }
        }

        return allow
      },
      navigateToTaskScope(object) {
        this.$store.commit('storeTaskToolbarState', true);
        this.$store.commit('storeActiveTask', object);
        if (object.scope_type == 'App\\Activity\\Models\\Activity') {
          this.$router.push({ name: 'activities.view', params: { slug: object.scope.slug }, query: { task: object.id }})
        }
        if (object.scope_type == 'App\\Process\\Models\\Process') {
          this.$router.push({ name: 'processes.view', params: { slug: object.scope.slug }, query: { task: object.id }})
        }
        if (object.scope_type == 'App\\System\\Models\\System') {
          this.$router.push({ name: 'systems.view', params: { slug: object.scope.slug, }, query: { task: object.id }})
        }
        if (object.scope_type == 'App\\Maintenance\\ThirdParty\\Models\\ThirdParty') {
          this.$router.push({ name: 'contracts.view', params: { slug: object.scope.slug, }, query: { task: object.id }})
        }
      },
      minimizeTask() {
        var element = document.getElementsByClassName('modal');
        // Task panels aren't modals (US 9478)
        if (element.length) {
          element[0].classList.add("bottom-left");
        }
        // this.submitForm = true
        this.$store.commit('storeLastClosedTask', this.selectedTask);
      },
      completeTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        if (
          ((this.selectedTask && this.selectedTask.add_attachments == 'Mandatory' && ((this.selectedTask.media && this.selectedTask.media.length) || (this.selectedTask.links && this.selectedTask.links.length))) ||
          (this.selectedTask && this.selectedTask.add_attachments != 'Mandatory')) &&
          ((this.selectedTask && this.selectedTask.add_description == 'Mandatory' && this.taskForm.remarks) ||
          (this.selectedTask && this.selectedTask.add_description != 'Mandatory')) &&
          this.answer
        ) {
          piincHttp.put('tasks/' + this.selectedTask.id, {
            remarks: this.taskForm.remarks,
            response: this.answer ? this.answer : undefined,
            status: 'completed'
          }).then(function(response) {
            self.$toastr('success', self.$t('tasks.modal.success'))
            self.buttonDisabled = false;

            if (self.taskList.length > 1) {
              let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
              if (index < self.taskList.length - 1) {
                self.selectedTask = self.taskList[index + 1]
              } else {
                self.selectedTask = self.taskList[0]
              }
              self.taskList.splice(index, 1);
              self.loadTaskById(self.selectedTask.id);
            } else {
              var element = document.getElementsByClassName('task-modal');
              element[0].classList.add("hide-task-modal");
              self.$refs['all-done'].show()
            }
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          if (!this.answer) {
            this.error += ' ' + this.$t('tasks.modal.response_error_message')
          }
          if ((this.selectedTask.add_attachments == 'Mandatory' && this.selectedTask.media && !this.selectedTask.media.length) && (this.selectedTask.add_attachments == 'Mandatory' && this.selectedTask.links && !this.selectedTask.links.length)) {
            this.error += ' ' + this.$t('tasks.modal.attachments_error_message')
          }
          if (this.selectedTask.add_description == 'Mandatory' && !this.taskForm.remarks) {
            this.error += ' ' + this.$t('tasks.modal.description_error_message')
          }
        }

      },
      hideDoneModal() {
        this.$refs['all-done'].hide()
        this.doNotMinimize = true
        this.$refs['task-modal'].hide()
        this.$emit('reloadContent');
        this.$store.commit('storeUpdatePage', true);
        this.$store.commit('storeTaskToolbarState', false);
        this.$store.commit('storeActiveTask', {});
      },
      completeSystemRiskTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        if (
          this.taskForm.remarks != '' &&
          this.selectedConfidentialityImpact && this.selectedConfidentialityImpact.value &&
          this.selectedIntegrityImpact && this.selectedIntegrityImpact.value &&
          this.selectedAvailabilityImpact && this.selectedAvailabilityImpact.value &&
          this.taskForm.rto != '' &&
          this.taskForm.rpo != '' &&
          this.rtoInterval && this.rtoInterval.value &&
          this.rpoInterval && this.rpoInterval.value
        ) {
          piincHttp.put('tasks/' + this.selectedTask.id, {
            remarks: this.taskForm.remarks,
            confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
            integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
            availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
            rto_number: this.taskForm.rto,
            rto_type: this.rtoInterval ? this.rtoInterval.value : '',
            rpo_number: this.taskForm.rpo,
            rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
            status: 'completed'
          }).then(function(response) {
            self.$toastr('success', self.$t('tasks.modal.success'))
            self.buttonDisabled = false;

            if (self.taskList.length > 1) {
              let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
              if (index < self.taskList.length - 1) {
                self.selectedTask = self.taskList[index + 1]
              } else {
                self.selectedTask = self.taskList[0]
              }
              self.taskList.splice(index, 1);
              self.loadTaskById(self.selectedTask.id);
            } else {
              var element = document.getElementsByClassName('task-modal');
              element[0].classList.add("hide-task-modal");
              self.$refs['all-done'].show()
            }
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = '';
          self.buttonDisabled = false;
          this.error = this.$t('tasks.modal.all_fields_error_message')
        }

      },
      saveTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          response: this.answer ? this.answer : ''
        }).then(function(response) {
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

      },
      previousTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          response: this.answer ? this.answer : undefined
        }).then(function(response) {
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index > 0) {
          this.selectedTask = this.taskList[index - 1]
        } else {
          this.selectedTask = this.taskList[this.taskList.length - 1]
        }

        self.loadTaskById(this.selectedTask.id);

      },
      nextTask() {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        this.error = ''

        piincHttp.put('tasks/' + this.selectedTask.id, {
          remarks: this.taskForm.remarks,
          confidentiality: this.selectedConfidentialityImpact ? this.selectedConfidentialityImpact.value : '',
          integrity: this.selectedIntegrityImpact ? this.selectedIntegrityImpact.value : '',
          availability: this.selectedAvailabilityImpact ? this.selectedAvailabilityImpact.value : '',
          rto_number: this.taskForm.rto,
          rto_type: this.rtoInterval ? this.rtoInterval.value : '',
          rpo_number: this.taskForm.rpo,
          rpo_type: this.rtoInterval ? this.rpoInterval.value : '',
          response: this.answer ? this.answer : undefined
        }).then(function(response) {
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

        let index = _.findIndex(self.taskList, function(o) { return o.id == self.selectedTask.id })
        if (index < this.taskList.length - 1) {
          this.selectedTask = this.taskList[index + 1]
        } else {
          this.selectedTask = this.taskList[0]
        }

        self.loadTaskById(self.selectedTask.id);

      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      openDeleteAttachmentModal(object) {
        this.selectedFile = object
        this.showDeleteAttachmentModal = true
      },
      closeDeleteAttachmentModal () {
        this.selectedFile = {}
        this.showDeleteAttachmentModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      openDeleteLinkModal(object) {
        this.selectedLink = object
        this.showDeleteLinkModal = true
      },
      closeDeleteLinkModal () {
        this.selectedLink = {}
        this.showDeleteLinkModal = false;
        this.loadTaskById(this.selectedTask.id, true);
      },
      handleLink() {
        let self = this;
        let formData = new FormData();

        if (!this.inputLink.startsWith('http')) {
          this.inputLink = 'http://' + this.inputLink
        }

        formData.append("url", this.inputLink);
        formData.append("name", this.inputLinkName);
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        piincHttp.post('links', formData).then(function() {
          self.inputLink = ''
          self.inputLinkName = ''
          self.loadTaskById(self.selectedTask.id, true);
          self.showInput = false
        }, function() {})
      },
      downloadMedia(object){
        piincHttp.get('documents/' + object.id + '/download', {
          responseType: 'blob',
          params: {
            task: this.selectedTask.id
          }
        }).then(function(response) {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.download = object.file_name;

          link.click();
          link.remove()
          window.URL.revokeObjectURL(url);
        }, function() {});
      },
      loadTaskById(id, ignorePopulate) {
        let self = this;
        piincHttp.get('tasks/' + id).then(function(response) {
          self.selectedTask = response.data;
          self.project_progress = self.selectedTask.project.user_progress.progress;
          if (!ignorePopulate) {
            self.populateForm()
          }
        }, function() {});
      },
      loadTaskGuide() {
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';
        let self = this;
        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Task',
            scope: 'assessment_task',
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.welcomeGuide = response.data.items[0]
          }
        }, function() {});
      },
      onFileChange(file) {
        let files = file.target.files;
        let self = this;
        let formData = new FormData();
        let sizeError = false;

        for (var i = 0; i < files.length; i++) {
          // Equal to 10 MB
          if (files[i].size > 10485760) {
            sizeError = true;
          }
          formData.append('document[]', files[i]);
        }

        formData.append("name", "documents");
        formData.append("model_type", this.selectedTask.who_am_i);
        formData.append("model_id", this.selectedTask.id);

        if (sizeError) {
          this.error = this.$t('system.file_size')
        } else {
          piincHttp.post('documents', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function() {
            self.error = ''
            self.loadTaskById(self.selectedTask.id, true);
          }, function(error) {
            self.error = error.data.message;
            if (error.data.errors['document.0']) {
              self.error += ' ' + error.data.errors['document.0'][0]
            }
          })
        }
      },
    },
    created () {

    }
  }
</script>
